<template>
    <BaseForm>
        <template #fields>
            <MultiLink
                :label="$t('extra-systems')"
                :links="values.extraSystems"
                :error-messages="errors.extraSystems"
                @input="setFieldValue('extraSystems', $event)"
                @delete="setFieldValue('extraSystems', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesSystemsSchema } from '../schemas';

defineProps<{ seriesId: string }>();

const { series, createEventSeriesMultiLink } = useEventSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventSeriesMultiLink);

const extraSystemsId = computed(() => series.value?.extraSystems?.id);

const extraSystemsLinks = computed(() => series.value?.extraSystems?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSeriesSystemsSchema,
    computed(() => ({
        extraSystems: getFormFieldLinks(extraSystemsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: extraSystemsId.value, fieldName: 'extraSystems', links: values.value.extraSystems },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
